import type { RoutesNamesList } from '@typed-router/__routes'

export async function handleFileSelect(client: string, path: string[], hash?: string, routeName: RoutesNamesList = 'client-view-path'): Promise<void> {
  await navigateTo({ name: routeName, params: { client, path }, hash })
}
